import React from 'react';

interface MarkAsReadButtonProps {
	onClick: () => void;
	ariaLabel?: string;
}

export const MarkAsReadButton = ({ onClick, ariaLabel = 'Mark as read' }: MarkAsReadButtonProps) => (
	<button
		type="button"
		className="mark-as-read-btn"
		onClick={onClick}
		aria-label={ariaLabel}
	>
		<span>Mark as read</span>
	</button>
);
